function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React from 'react';
import classnames from 'classnames';
import SetupFeeTooltip from 'swag-client-common/components/partials/setupfee-tooltip';
import { Price } from 'swag-client-common/utils/price';
import { pluralize } from 'swag-common/utils/strings';
import classes from './box-items-summary.scss';
export class BoxItemsSummary extends React.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "state", {
      isProdTimeChanged: false
    });
    _defineProperty(this, "setProdTime", prodTime => {
      const {
        onProductionTimeChange
      } = this.props;
      onProductionTimeChange(prodTime);
      this.setState({
        isProdTimeChanged: true
      });
    });
  }
  render() {
    const {
      isProdTimeChanged
    } = this.state;
    const {
      total,
      setupFee,
      oldSetupFee,
      itemPrice,
      prodTime,
      productionTimeList,
      wrapperClassName = '',
      onProductionTimeClick
    } = this.props;
    if (!productionTimeList[prodTime] && prodTime !== 0 && !isProdTimeChanged) {
      this.setProdTime(0);
      return null;
    }
    if (!productionTimeList[prodTime]) {
      return null;
    }
    const {
      name,
      time
    } = productionTimeList[prodTime];
    const isEditAvailable = productionTimeList.length > 1;
    const shouldShowOldSetupFee = oldSetupFee !== 0 && setupFee !== oldSetupFee;
    const shouldShowSetupFeeTooltip = setupFee && setupFee > 0;
    return /*#__PURE__*/React.createElement("div", {
      className: classes.container
    }, /*#__PURE__*/React.createElement("div", {
      className: classes.column
    }, /*#__PURE__*/React.createElement("span", {
      className: classes.title
    }, "Production Time:"), /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("span", {
      className: classes.timeName
    }, name, " - "), /*#__PURE__*/React.createElement("span", {
      onClick: onProductionTimeClick,
      className: classnames(classes.time, {
        [classes.disabled]: !isEditAvailable
      }),
      "data-button": "ProductionTime"
    }, isFinite(time) ? pluralize(time, 'Business Day', 's') : 'Default Business Days'), isEditAvailable && /*#__PURE__*/React.createElement("span", {
      className: classes.pencil
    }))), /*#__PURE__*/React.createElement("div", {
      className: classnames(classes.summary, wrapperClassName)
    }, /*#__PURE__*/React.createElement("div", {
      className: classes.item
    }, /*#__PURE__*/React.createElement("div", {
      className: classes.text
    }, "Each Box:"), /*#__PURE__*/React.createElement("div", {
      className: classes.blackBold,
      "data-text": "BoxItemPrice"
    }, Price.formatPrice(itemPrice))), /*#__PURE__*/React.createElement("div", {
      className: classes.item
    }, /*#__PURE__*/React.createElement("div", {
      className: classes.text
    }, "Setup Fee:"), shouldShowOldSetupFee && /*#__PURE__*/React.createElement("div", {
      className: classes.oldSetupFee,
      "data-text": "OldBoxSetupFee"
    }, Price.formatPrice(oldSetupFee)), /*#__PURE__*/React.createElement("div", {
      className: classnames(classes.blackBold, {
        [classes.stickyRight]: !shouldShowOldSetupFee && shouldShowSetupFeeTooltip
      }),
      "data-text": "BoxSetupFee"
    }, Price.formatPrice(setupFee)), !shouldShowOldSetupFee && shouldShowSetupFeeTooltip && /*#__PURE__*/React.createElement(SetupFeeTooltip, {
      infoWrapperClassName: classes.setupFeeInfoWrapper,
      infoButtonClassName: classes.infoButton
    })), /*#__PURE__*/React.createElement("div", {
      className: classes.item
    }, /*#__PURE__*/React.createElement("div", {
      className: classes.text
    }, "Total:"), /*#__PURE__*/React.createElement("div", {
      className: classes.pinkBold,
      "data-text": "BoxProductsTotal"
    }, Price.formatPrice(total)))));
  }
}